import { useState, useEffect, ChangeEvent, FormEvent } from 'react';
import { API } from '@aws-amplify/api';

// https://www.freecodecamp.org/news/how-to-build-forms-in-react/
export default function Admin(myprops) {
  var ucs = myprops.ucs;
  const [formData, setFormData] = useState(ucs.customer);
  const [inputError, setInputError] = useState(null);  
  console.log('ucs passed in', ucs);

  var var2 = ucs;
  console.log('var 2 obj-->',var2,"<---") 

  console.log('var 2-->',JSON.stringify(var2),"<---") 
  console.log('into admin json.stringified passed prop-->',JSON.stringify(ucs),"<---")
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [creds, setCreds] = useState();

  async function saveCustomerData(customerDataSet) {
    console.log('starting the save')

    const apiName = 'api60cb0321';
    const path = '/customer/settings';
    const myInit = {
      body: customerDataSet, // replace this with attributes you need
      headers: {} // OPTIONAL
    };
    return await API.post(apiName, path, myInit);


  }
  
  function credCalc(u,p){
    console.log('called cred calculator')
    var creds = document.getElementById('creds');
    var decodedStringBtoA = u + ":" + p
    //creds.value =  btoa(decodedStringBtoA);
    var concatted = btoa(decodedStringBtoA) + "###" + encodeURI(btoa(decodedStringBtoA));
    console.log(concatted);
    creds.value = concatted;
  }

return (
  <div>
  <h2>Administrative Settings</h2>   
  </div>
);
}